export default __webpack_public_path__ + "static/media/medscheme.71e85f4d.png";